<template>
  <el-main :class="sidebar ? 'margin-side' : ''"><router-view/></el-main>
</template>

<script>
export default {
  props: {
    sidebar: {
      type: Boolean,
      required: true,
    },
  },
  name: 'TheContent',
};
</script>

<style lang="scss" scoped>
  .el-main {
    height: calc(100vh - 50px);
    padding: 35px 30px 30px 30px;
  }
  .margin-side { margin-left: 59px; }
</style>
